if (!customElements.get('production-showcase')) {
  class ProductionShowcase extends HTMLElement {
    connectedCallback() { this.splideInstance=null; this.initCarousel(); this.initHotspots(); }
    disconnectedCallback() { if(this.splideInstance) this.splideInstance.destroy(); }
    initCarousel() {
      var el=this.querySelector('.splide'); if(!el||typeof Splide==='undefined') return;
      var hasMany=el.querySelectorAll('.splide__slide').length>1;
      this.splideInstance=new Splide(el,{type:'fade',rewind:true,autoplay:this.dataset.autoplay==='true',interval:parseInt(this.dataset.autoplaySpeed)||5000,pauseOnHover:true,pagination:false,arrows:hasMany,speed:600}).mount();
      this.splideInstance.on('move',()=>this.closeAllTooltips());
    }
    initHotspots() {
      var isMobile='ontouchstart' in window, hs=this.querySelectorAll('.production-showcase__hotspot');
      hs.forEach(h=>{if(isMobile){h.addEventListener('click',(e)=>{e.preventDefault();e.stopPropagation();var vis=h.classList.contains('is-tooltip-visible');this.closeAllTooltips();if(!vis)h.classList.add('is-tooltip-visible');});}});
      document.addEventListener('click',(e)=>{if(!e.target.closest('.production-showcase__hotspot'))this.closeAllTooltips();});
    }
    closeAllTooltips(){this.querySelectorAll('.production-showcase__hotspot').forEach(h=>h.classList.remove('is-tooltip-visible'));}
  }
  customElements.define('production-showcase', ProductionShowcase);
  if(window.Shopify&&window.Shopify.designMode){
    document.addEventListener('shopify:section:load',(e)=>{var el=e.target.querySelector('production-showcase');if(el){el.disconnectedCallback();el.connectedCallback();}});
    document.addEventListener('shopify:block:select',(e)=>{var sc=e.target.closest('production-showcase');if(!sc||!sc.splideInstance)return;var sl=e.target.closest('.splide__slide');if(sl){var idx=[...sl.parentElement.children].indexOf(sl);sc.splideInstance.go(idx);}});
  }
}
